import { create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  CreateIbFormSubmissionRequestType,
  CreateIbFormSubmissionResponseType,
  CreatePublicIbFormSubmissionRequestType,
  CreatePublicIbFormSubmissionResponseType,
  GetFormReferralCodeResponseType,
  GetIbFormDetailsRequestType,
  GetIbFormDetailsResponseType,
  GetIbFormSubmissionDetailsRequestType,
  GetIbFormSubmissionDetailsResponseType,
  GetPublicIbFormDetailsRequestType,
  GetPublicIbFormDetailsResponseType,
  UserFormReferralTrackRequestType,
  UserFormReferralTrackResponseType
} from './types';

import { FormsServiceTypes } from '.';

class FormsService implements FormsServiceTypes {
  api: Record<string, any>;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['FORMS_BASE_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  getIbFormDetails(
    requestObject: GetIbFormDetailsRequestType
  ): Promise<GetIbFormDetailsResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'get_ib_form_details/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getIbFormSubmissionDetails(
    requestObject: GetIbFormSubmissionDetailsRequestType
  ): Promise<GetIbFormSubmissionDetailsResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'get_ib_form_submission_details/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getPublicIbFormDetails(
    requestObject: GetPublicIbFormDetailsRequestType
  ): Promise<GetPublicIbFormDetailsResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'get_public_ib_form_details/v1/',
      requestObject,
      apiMethods.post
    );
  }

  createIbFormSubmission(
    requestObject: CreateIbFormSubmissionRequestType
  ): Promise<CreateIbFormSubmissionResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'create_ib_form_submission/v1/',
      requestObject,
      apiMethods.post
    );
  }

  createPublicIbFormSubmission(
    requestObject: CreatePublicIbFormSubmissionRequestType
  ): Promise<CreatePublicIbFormSubmissionResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'create_public_ib_form_submission_details/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getFormReferralCode({
    formId
  }: {
    formId: string;
  }): Promise<GetFormReferralCodeResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      `form/${formId}/referral_code/v1/`,
      {},
      apiMethods.get
    );
  }

  userFormReferralTrack(
    requestObject: UserFormReferralTrackRequestType
  ): Promise<UserFormReferralTrackResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'user/referral/track/v1/',
      requestObject,
      apiMethods.post
    );
  }
}

export { FormsService };
